<div class="card-content card-register-content">
  <mat-tab-group [selectedIndex]="defaultTabIndex" animationDuration="0ms">
    <!--tab:登入-->
    <mat-tab [label]="'login-register.login' | translate">
      <form
        [formGroup]="loginForm"
        (ngSubmit)="onLoginSubmit()"
        class="register-form"
      >
        <div class="input-block">
          <label class="input-title input-text-required" for="login-idNumber">{{
            'login-register.idNumber' | translate
          }}</label>
          <div class="input-group input-btn-right">
            <input
              id="login-idNumber"
              matInput
              formControlName="idNumber"
              [placeholder]="
                'login-register.idNumber-login-placeholder' | translate
              "
              [maxLength]="idNumberMaxLength"
              (keydown.enter)="onLoginSubmit()"
              [ngClass]="{
                'input-error':
                  showLoginFormError && loginForm.get('idNumber')?.invalid,
              }"
            />
            <!-- <button
              mat-icon-button
              type="button"
              class="input-password-btn"
              (click)="toggleLoginIdNumberVisibility()"
            >
              <img
                [src]="
                  isLoginIdNumberVisible
                    ? 'assets/img/i-eye.svg'
                    : 'assets/img/i-eye-closed.svg'
                "
                alt="toggle visibility"
              />
            </button> -->
            @if (showLoginFormError && loginForm.get('idNumber')?.invalid) {
              <mat-error class="input-error-msg">{{
                getLoginFormIdNumberErrorMessage()
              }}</mat-error>
            }
          </div>
        </div>
        <div class="input-block">
          <label class="input-title input-text-required" for="password">{{
            'login-register.password' | translate
          }}</label>
          <div class="input-group input-btn-right">
            <input
              id="password"
              matInput
              [type]="isPasswordVisible ? 'text' : 'password'"
              formControlName="password"
              [placeholder]="'login-register.password-placeholder' | translate"
              [minlength]="passwordMinLength"
              [maxLength]="passwordMaxLength"
              (keydown.enter)="onLoginSubmit()"
              [ngClass]="{
                'input-error':
                  showLoginFormError && loginForm.get('password')?.invalid,
              }"
            />
            <button
              mat-icon-button
              type="button"
              class="input-password-btn"
              (click)="togglePasswordVisibility()"
            >
              <img
                [src]="
                  isPasswordVisible
                    ? 'assets/img/i-eye.svg'
                    : 'assets/img/i-eye-closed.svg'
                "
                alt="toggle visibility"
              />
            </button>
            @if (showLoginFormError && loginForm.get('password')?.invalid) {
              <mat-error class="input-error-msg">{{
                getPasswordErrorMessage()
              }}</mat-error>
            }
          </div>

          <button
            mat-button
            type="button"
            class="btn-text-underline btn-size-s"
            (click)="openForgotPasswordDialog()"
          >
            {{ 'common.button.forgot-password' | translate }}?
          </button>
        </div>

        <!--TODO forward to forgot password page-->
        <button
          mat-button
          type="submit"
          class="btn-fill-primary btn-size-l"
          [disabled]="isLoginProcessing || (showLoginFormError && loginForm.invalid)"
        >
          {{ 'common.button.login' | translate }}
        </button>
      </form>
    </mat-tab>

    <!--tab:註冊-->
    <mat-tab [label]="'login-register.register' | translate">
      <form
        [formGroup]="registerForm"
        (ngSubmit)="onRegisterSubmit()"
        class="register-form"
      >
        <div class="input-block">
          <label class="input-title input-text-required" for="gender">{{
            'login-register.gender' | translate
          }}</label>
          <mat-radio-group formControlName="gender" id="gender">
            <mat-radio-button [value]="API_PARAMS.GENDER.MALE"
              >{{ 'login-register.gender-male' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="API_PARAMS.GENDER.FEMALE"
              >{{ 'login-register.gender-female' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="input-block">
          <label class="input-title input-text-required" for="birthday">{{
            'login-register.birthday' | translate
          }}</label>
          <div class="input-group input-btn-right">
            <input
              id="birthday"
              appDateInput
              matInput
              [matDatepicker]="picker"
              [placeholder]="DATE_FORMAT"
              formControlName="birthday"
              (keydown.enter)="onRegisterSubmit()"
              [ngClass]="{
                'input-error':
                  showRegisterFormError &&
                  registerForm.get('birthday')?.invalid,
              }"
            />
            <mat-datepicker-toggle [for]="picker" class="input-date-btn">
              <ng-container matDatepickerToggleIcon>
                <img
                  src="assets/img/i-calendar.svg"
                  alt=""
                  height="25"
                  width="24"
                />
              </ng-container>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (
              showRegisterFormError && registerForm.get('birthday')?.invalid
            ) {
              <mat-error class="input-error-msg">{{
                getBirthdayErrorMessage()
              }}</mat-error>
            }
          </div>
        </div>
        <div class="input-block">
          <label class="input-title input-text-required" for="name">{{
            'login-register.name' | translate
          }}</label>
          <div class="input-group input-btn-right">
            <input
              id="name"
              matInput
              formControlName="name"
              appChineseEnglishSpaceOnly
              [maxLength]="nameMaxLength"
              [placeholder]="'login-register.name-placeholder' | translate"
              (keydown.enter)="onRegisterSubmit()"
              [ngClass]="{
                'input-error':
                  showRegisterFormError && registerForm.get('name')?.invalid,
              }"
            />
            @if (showRegisterFormError && registerForm.get('name')?.invalid) {
              <mat-error class="input-error-msg">{{
                getNameErrorMessage()
              }}</mat-error>
            }
          </div>
        </div>
        <div class="input-block">
          <label
            class="input-title input-text-required"
            for="register-idNumber"
            >{{ 'login-register.idNumber' | translate }}</label
          >
          <div class="input-group input-btn-right">
            <input
              id="register-idNumber"
              formControlName="idNumber"
              matInput
              [maxLength]="idNumberMaxLength"
              (keydown.enter)="onRegisterSubmit()"
              [placeholder]="
                'login-register.idNumber-register-placeholder' | translate
              "
              [ngClass]="{
                'input-error':
                  showRegisterFormError &&
                  registerForm.get('idNumber')?.invalid,
              }"
            />
            <!-- <button
              mat-icon-button
              type="button"
              class="input-password-btn"
              (click)="toggleRegisterIdNumberVisibility()"
            >
              <img
                [src]="
                  isRegisterIdNumberVisible
                    ? 'assets/img/i-eye.svg'
                    : 'assets/img/i-eye-closed.svg'
                "
                alt="toggle visibility"
              />
            </button> -->
            @if (
              showRegisterFormError && registerForm.get('idNumber')?.invalid
            ) {
              <mat-error class="input-error-msg">{{
                getRegisterFormIdNumberErrorMessage()
              }}</mat-error>
            }
          </div>
          <div class="input-warn-msg">
            <img
              width="16"
              height="16"
              ngSrc="/assets/img/i-warn-outline.svg"
              alt=""
            />
            <span>{{
              'login-register.idNumber-register-hint' | translate
            }}</span>
          </div>
        </div>
        <button
          mat-button
          type="submit"
          class="btn-fill-primary btn-size-l"
          [disabled]="isRegisterProcessing || (showRegisterFormError && registerForm.invalid)"
        >
          {{ 'common.button.register' | translate }}
        </button>
      </form>
    </mat-tab>
  </mat-tab-group>
  <!--共用:card footer-->
  <div class="card-footer">
    <span
      class="card-footer-text"
      [innerHTML]="'login-register.hint' | translate"
    ></span>
  </div>
</div>

<!--btn-test 測試按鈕-->
<!-- @if (devService.isDev()) {
  <div class="btn-test">
    <mat-button-toggle-group
      name="login-error"
      aria-label="login-error"
      [(ngModel)]="loginCondition"
    >
      <mat-button-toggle [value]="-1">pass</mat-button-toggle>
      <mat-button-toggle [value]="1">{{
        'error.account-locked.title' | translate
      }}</mat-button-toggle>
      <mat-button-toggle [value]="2">{{
        'error.otp-error.reached-otp-limit' | translate
      }}</mat-button-toggle>
      <mat-button-toggle [value]="3">{{
        'error.id-or-password-error.title' | translate
      }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
} -->

<!--btn-test 測試按鈕-->
<!-- @if (devService.isDev()) {
  <div class="btn-test">
    <mat-button-toggle-group
      name="login-error"
      aria-label="login-error"
      [(ngModel)]="registerCondition"
    >
      <mat-button-toggle [value]="-1"
        >pass(身分證已有在國泰健檢DB)</mat-button-toggle
      >
      <mat-button-toggle [value]="1">已經註冊新帳號國泰健檢</mat-button-toggle>
      <mat-button-toggle [value]="2">未註冊新帳號國泰健檢</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
} -->
